var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"align-center fill-height"},[_c('v-card',[_c('h2',{staticClass:"text-h4"},[_vm._v(" You're lost ")]),_vm._v(" 404 or something like that ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }